import { clientActivationsHistoryRoute } from './ClientActivationsHistory/route';
import { clientIdentityVerificationRoute } from './ClientIdentityVerificationPage/route';
import { clientPsd2ConnectedBanksRoute } from './ClientPsd2ConnectedBanksPage/route';
import { clientValidActivationsRoute } from './ClientValidActivationsPage/route';
import { clientApplicationsRoute } from './route';

export const clientApplicationsRoutes = clientApplicationsRoute.addChildren([
	clientValidActivationsRoute,
	clientActivationsHistoryRoute,
	clientPsd2ConnectedBanksRoute,
	clientIdentityVerificationRoute,
]);
